import { Config } from '../types/types';

const shared = {
  isDev: process.env.NODE_ENV === 'development',
  isProd: process.env.REACT_APP_ENVIRONMENT === 'p',
  azureAdTenantId: process.env.REACT_APP_AZURE_AD_TENANT_ID || '',
  azureAdClientId: process.env.REACT_APP_AZURE_AD_CLIENT_ID || '',
  azureAdScopeIdForApi: process.env.REACT_APP_AZURE_AD_SCOPE_ID_FOR_API || '',
  manifestApiUrl: process.env.REACT_APP_MANIFEST_API_URL || '',
};

const envD: Config = {
  ...shared,
  savingPermission: true,
};

const envP: Config = {
  ...shared,
  savingPermission: true,
};

const envQ: Config = {
  ...shared,
  savingPermission: true,
};


export const getConfig = (env: string | undefined): Config => {
  switch (env) {
    case 'd':
      return envD;
    case 'q':
      return envQ;
    case 'p':
    default:
      return envP;
  }
};

const config = getConfig(process.env.REACT_APP_ENVIRONMENT);

export default config;
